import {
  isUserRouteUrl,
  decodeUserRoute,
  resolveUserRoute,
} from "@shared/schemas/user-route-request.schemas";
import { getEventSubdomainFromHostname } from "@shared/utils/subdomain-url.utils";
import type { UserRouteRequest } from "@shared/schemas/user-route-request.schemas";
import type { EventRouteContext } from "@shared/constants/user-app-routes.constants";
import { applicationLogger } from "../logger/application-logger.singleton";

function buildEventRouteContext(
  request: UserRouteRequest,
  isEventSubdomain: boolean,
): EventRouteContext | undefined {
  if (
    request.type === "forEvent" ||
    request.type === "forEventParticipant" ||
    request.type === "eventLandingPage"
  ) {
    return {
      eventIdPublic: request.eventIdPublic,
      isEventSubdomain,
    };
  }

  return undefined;
}

export function resolveRedirect(redirect: string): string {
  if (!isUserRouteUrl(redirect)) {
    return redirect;
  }

  try {
    const request = decodeUserRoute(redirect);
    const isEventSubdomain =
      getEventSubdomainFromHostname(window.location.hostname) !== null;
    const ctx = buildEventRouteContext(request, isEventSubdomain);

    return resolveUserRoute(request, ctx);
  } catch (error) {
    applicationLogger.warn(
      "Failed to resolve user-route:// redirect, falling back to root",
      [
        {
          redirect: redirect.slice(0, 80),
          error: error instanceof Error ? error.message : String(error),
        },
      ],
    );
    return "/";
  }
}
